exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".snackbar[data-v-8b5dad00]{font-size:20px}.dialog[data-v-8b5dad00]{z-index:200}", ""]);

// exports
